import React, { Component, } from "react";
import axios from "axios";
import ReactTable from "react-table";
import moment from "moment-timezone";
import { Grid, Typography, IconButton } from '@material-ui/core';
const getUserContactHistory = (userProfileId) => {
    return axios.get("/api/services/app/Advisors/GetUserContactHistory", { params: { userProfileId } });
};

class UserContactHistory extends Component {

    constructor(props) {
        super(props);

        this.state = {
            userProfileId: this.props.userProfileId,
            data: []

        };
    }

    componentDidMount = async() => {
        const data = await getUserContactHistory(this.state.userProfileId);
        this.setState({ data: data.data.result })

    }
    componentDidUpdate(prevProps, prevState) {


    }

    render() {

        let columns = [

             {
                Header: "Coach",
                accessor: "title",
                width: 250,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} >{row.original.advisor}</div>
                ),

            },
            {
                Header: "Year",
                accessor: "year",
                width: 90,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} >{row.original.year}</div>
                ),

            },
            {
                Header: "Month",
                accessor: "month",
                width: 90,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} >{row.original.month}</div>
                ),

            },
            {
                Header: "Last Contact Date",
                accessor: "date",
                width: 200,
                Cell: (row) => {
                    const lCont = row.value !== null ? moment.utc(row.value).tz("America/New_York").format("M/D/YY h:mm a") : "";
                    return <div className="dataCell" style={{ textAlign: "center" }}>{lCont}</div>;
                },

            }
            ,
            {
                Header: "# of Contacts",
                accessor: "numberOfContacts",
                width: 150,
                Cell: (row) => {
                    
                    return <div className="dataCell" style={{ textAlign: "center" }}>{row.original.numberOfContacts}</div>;
                },

            }
            


        ];
        


        return (
            <>
            <Typography variant="h6" align="center">
                                Contact History
                </Typography>
                <Typography variant="normal" align="center">
                    (Does not include Program Events)
                </Typography>
            <ReactTable
                data={this.state.data}
                minRows={0}
                columns={columns}
                defaultPageSize={50}
                className="-striped -highlight tableWrapper"
            />
            </>      
        );

    }
}

export default UserContactHistory;





